import {Component, inject, OnInit} from '@angular/core';
import {ContactDetailsComponent} from "../contact/contact-details/contact-details.component";
import {ContactFormComponent} from "../contact/contact-form/contact-form.component";
import {FooterComponent} from "../../common/footer/footer.component";
import {HeaderComponent} from "../../common/header/header.component";
import {IonCol, IonContent, IonRow} from "@ionic/angular/standalone";
import {LanguageService} from '../../core/language.service';
import {formTypes, pages} from '../../configs/config';
import {Meta, Title} from '@angular/platform-browser';
import {B2bSectionComponent} from "../components/b2b-section/b2b-section.component";

@Component({
    selector: 'app-b2b',
    templateUrl: './b2b.component.html',
    styleUrls: ['./b2b.component.scss'],
    imports: [
        ContactDetailsComponent,
        ContactFormComponent,
        FooterComponent,
        HeaderComponent,
        IonCol,
        IonContent,
        IonRow,
        B2bSectionComponent
    ]
})
export class B2bComponent  implements OnInit {


  languageService: LanguageService = inject(LanguageService);
  formType = formTypes.b2b;
  content: any;
  constructor() { }

  title: Title = inject(Title);
  meta: Meta = inject(Meta);
  async ngOnInit() {

    this.title.setTitle('Hassle-Free Property Management in Riyadh | Submit Your Property Now');

    this.meta.addTags([
      {property: 'og:title', content: 'Hassle-Free Property Management in Riyadh | Submit Your Property Now'},
      {name: 'description', content: 'Experience hassle-free property ownership. Submit your property to Satel and let our experts handle all aspects of property management, from tenant screening to maintenance.'},
      {property: 'og:description', content: 'Experience hassle-free property ownership. Submit your property to Satel and let our experts handle all aspects of property management, from tenant screening to maintenance.'},
      {property: 'og:image', content: 'https://satel.sa/assets/inner/service-inner-1-min.png'},
      {property: 'og:site_name', content: 'satel.sa'},
      {property: 'og:url', content: `https://satel.sa/`},
      {property: 'og:type', content: 'article'},
      {name: 'twitter:site', content: 'satel.sa'},
      {name: 'twitter:title', content: 'Hassle-Free Property Management in Riyadh | Submit Your Property Now'},
      {name: 'twitter:description', content: 'Experience hassle-free property ownership. Submit your property to Satel and let our experts handle all aspects of property management, from tenant screening to maintenance.'},
      {name: 'twitter:card', content: 'summary'},
      {name: 'twitter:image', content: 'https://satel.sa/assets/inner/service-inner-1-min.png'}
    ]);
    this.content = await this.languageService.loadContent(pages.b2bPage);
    console.log(this.content)
  }
}
